import React, { useCallback, useEffect, useRef, useState } from 'react'
import axiosInstance from '../../api/axiosInstance'
import LogRow from '../../Components/LogRow/LogRow'
import { Autocomplete, Box, Snackbar, TextField, Typography } from '@mui/material'
import FilterLoader from '../../Components/FilterLoader/FilterLoader'

const Logs = () => {


  const [businesses, setBusinesses] = useState([])
  
  const getBusinesses = async () => {
    try {
      const res = await axiosInstance.get("/business")
      if (res.data) {
        setBusinesses(res.data)
      } else {
        setBusinesses([])
      }
    } catch (err) {
      console.log(err)
    }
  }

  const syncTypes=[
    {name:"fatureD",value:0},
    {name:"fatureH",value:1},
    {name:"klient",value:2},
    {name:"fatureP",value:3},
    {name:"klientDroid",value:4},
    //{name:"Mandat Pagese",value:2},
    //{name:"Mandat Arketimi",value:2},
    {name:"Koordinata",value:7}
    
  ]

  const [page, setPage] = useState(1)
  const [totalRows, setTotalRows] = useState(-1)
  const [vhost, setVhost] = useState(null)
  const [syncType, setSyncType] = useState(null)
  const [isLoading, setIsLoading] = useState(false);
  const [search, setSearch] = useState("")

  const resetState = () =>{
    setPage(1)
    setTotalRows(-1)
    setLogs([])
  }


  const [logs, setLogs] = useState([])
  const scrollableRef = useRef(null);


  const getLogs = async () => {
    if (totalRows === logs.length) {
      return
    }
    setIsLoading(true);
    try {
      const data = {
        page: page,
        rows: 20,
        vhost: vhost ? vhost.vhost : "",
        search: search,
        type: syncType!=null ? syncType.value : null

      }
      const res = await axiosInstance.post(`Logs/filter`, data)
      setLogs(prev => [...prev, ...res.data.logs])
      setTotalRows(res.data.totalRows === 0 ? -1 : res.data.totalRows)
      setPage(prev => prev + 1)

    } catch (err) {
      console.log(err)
    } finally {
      setIsLoading(false)
    }
  }


  useEffect(() => {
    getBusinesses()
    getLogs()

  }, [])

  const [open, setOpen] = React.useState(false);
  const handleClick = () => {
    setOpen(true);
  };

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    setOpen(false);
  };


  useEffect(() => {
    const handleScroll = () => {
      const { scrollTop, clientHeight, scrollHeight } =
        document.documentElement;
      if (scrollTop + clientHeight >= scrollHeight && !isLoading) {
        getLogs();
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [getLogs, isLoading]);



  const firstRender = useRef(true);

  useEffect(() => {
    if (firstRender.current) {
      return;
    }
    getLogs();


  }, [vhost])


  useEffect(()=>{
      if (firstRender.current) {
        return;
      }
      getLogs();
  },[syncType])


  useEffect(() => {
    if (firstRender.current) {
      firstRender.current = false;
      return;
    }

    const timer = setTimeout(() => {
      if (search !== "") {
        setLogs([])
        getLogs();
      }

    }, 500);
    return () => clearTimeout(timer);


  }, [search])


  return (
    <div style={{ padding: "16px", overflow: "auto" }} ref={scrollableRef} >
      <Box display={"flex"} alignItems={"center"} gap={1} flexWrap={"wrap"}>
        <Autocomplete
          sx={{ maxWidth: "500px", minWidth: "200px" }}
          fullWidth
          size='small'
          disablePortal
          id="combo-box-demo"
          value={vhost}
          onChange={(_, newVal) => {
            if (newVal) {
              resetState()
              setVhost(newVal)
            } else {
              resetState()
              setVhost(null)
            }
          }}
          options={businesses}
          getOptionLabel={op => op.name + ` (${op.vhost})`}
          renderInput={(params) => <TextField {...params} label="Bussiness" />}
        />
        <TextField
          sx={{ maxWidth: "500px", minWidth: "200px" }}
          fullWidth
          size='small'
          label="Search..." value={search} onChange={e => {
            setSearch(e.target.value);
            if (e.target.value === "") {
              getLogs();
            }
            if (page !== 1) {
              setPage(1)
              setTotalRows(-1)
            }
          }} />

        <Autocomplete
          sx={{ maxWidth: "500px", minWidth: "200px" }}
          fullWidth
          size='small'
          disablePortal
          id="combo-box-demo"
          value={syncType}
          onChange={(_, newVal) => {
            if (newVal) {
              resetState()
              setSyncType(newVal)
            } else {
              resetState()
              setSyncType(null)
            }
          }}
          options={syncTypes}
          getOptionLabel={(op)=>op.name}
          renderInput={(params) => <TextField {...params} label="Sync Type" />}
        />
      </Box>

      {
        logs && logs.length > 0 ?
          logs.map((log, i) => {
            return (
              <LogRow key={i} log={log} handleClick={handleClick} />
            )
          }) : !isLoading ? <Typography sx={{ my: 2 }}>No Data</Typography> : ""
      }
      {
        isLoading ? <Box display={"flex"} alignItems={"center"} justifyContent={"center"}><FilterLoader /></Box> : ""
      }
      <Snackbar
        open={open}
        autoHideDuration={3000}
        onClose={handleClose}
        message="Copied"
        color='success'
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      />
    </div>
  )
}

export default Logs